module.exports = __webpack_public_path__ + "img/jiuzhang-back-phone.7139bfac.png";